import React from 'react';
import RuleLink from '../components/RuleLink';
import { getFeatureDisplayName, isFeatureLocked } from '../../../constants/analyticsConstants';

/**
 * Одна детекция в профиле камеры (Part 4, раздел 4.1; ТЗ задачи 21, 22).
 *
 * Три признака показываются раздельно и не сливаются в один чекбокс:
 *
 * - `effective_enabled` — фактическое состояние детектора, его считает backend;
 * - `manual_enabled` — желание администратора держать детектор включённым;
 * - `required_by_rules` — детектор держат активные правила.
 *
 * Классический случай: manual=false, required=true, effective=true. Чекбокс при
 * этом обязан остаться выключенным, иначе после отключения последнего правила
 * пользователь получит не то состояние, которое видел.
 *
 * `profile` нужен только для isFeatureLocked (людей нельзя выключить в режиме
 * «Люди и СИЗ») — блокировка ставится заранее, не дожидаясь 409 от backend.
 */
const DetectionCapabilityRow = ({ feature, profile, busy = false, disabled = false, onToggleManual }) => {
  const rules = Array.isArray(feature.required_by_rule_items) ? feature.required_by_rule_items : [];
  const checkboxId = `vio-feature-${feature.feature_id}`;
  const lock = isFeatureLocked(feature, profile);

  return (
    <li className="vio-feature">
      <div className="vio-feature-head">
        <span className="vio-feature-name">{getFeatureDisplayName(feature)}</span>
        <span className={`vio-badge vio-badge--${feature.effective_enabled ? 'enabled' : 'disabled'}`}>
          {feature.effective_enabled ? 'ВКЛЮЧЕНО' : 'ВЫКЛЮЧЕНО'}
        </span>
      </div>

      <label className="vio-checkbox" htmlFor={checkboxId}>
        <input
          id={checkboxId}
          type="checkbox"
          checked={Boolean(feature.manual_enabled)}
          disabled={busy || disabled || feature.available === false || lock.locked}
          onChange={(event) => onToggleManual(feature, event.target.checked)}
        />
        Оставлять включённой вручную
      </label>

      {lock.locked && <p className="vio-field-hint">{lock.reason}</p>}

      {feature.required_by_rules && (
        <div className="vio-feature-rules">
          <span className="vio-feature-rules-title">Используется активными правилами:</span>
          {rules.length > 0 ? (
            <ul className="vio-feature-rules-list">
              {rules.map((rule) => (
                <li key={rule.rule_id}><RuleLink rule={rule} /></li>
              ))}
            </ul>
          ) : (
            <span className="vio-feature-rules-empty">Список правил недоступен</span>
          )}
        </div>
      )}

      {feature.available === false && (
        <p className="vio-field-hint">Детекция недоступна для этой камеры.</p>
      )}
    </li>
  );
};

export default DetectionCapabilityRow;
